import { connect } from 'react-redux'

import { IStoreState, IApplyPromotion } from '../../../types/index'

import ApplyPromotionModal from '../../../components/riders/riderdetails/promotions/ApplyPromotionModal'

import {
  getOrganizationPromotions
} from '../../../state/actions/organizations'
import {
  applyPromotion
} from '../../../state/actions/riders'
import {
  getOrgPromotions
} from '../../../state/selectors'

export function mapStateToProps(state: IStoreState) {
  const currentOrgId: string = state.organizations.currentOrgId as string

  return {
    orgId: currentOrgId,
    promotions: getOrgPromotions(state, currentOrgId)
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getAllPromotions: (orgId: string) => dispatch(getOrganizationPromotions(orgId)),
    applyPromotion: (promotion: IApplyPromotion) => dispatch(applyPromotion(promotion))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApplyPromotionModal)



// WEBPACK FOOTER //
// ./src/containers/riders/riderdetails/ApplyPromotionModal.ts